function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useRef, useState } from 'react';
import WebViewer from '@pdftron/webviewer';
import { Modal, ModalHeader, ModalBody, Alert } from 'reactstrap';
import { getFileExtension } from 'core/utils';
import { updateAnnotations } from '../../../attachments/actions';
import ReactAudioPlayer from "react-audio-player";
var downloadFile = function downloadFile(instance) {
  return instance.downloadPdf({
    includeAnnotations: true,
    flatten: true
  });
};
var handleOnSuccess = function handleOnSuccess(element) {
  var parentEl = document.getElementById('saving-span');
  element.textContent = 'Saved!';
  element.classList.add('text-success');
  parentEl.classList.remove('d-none');
};
var handleOnError = function handleOnError(element) {
  var parentEl = document.getElementById('saving-span');
  element.textContent = 'Error saving... please try again?';
  element.classList.add('text-danger');
  parentEl.classList.remove('d-none');
};
var AttachmentPreviewer = function AttachmentPreviewer(_ref) {
  var attachment = _ref.attachment,
    show = _ref.show,
    toggle = _ref.toggle;
  var viewer = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    refVisible = _useState2[0],
    setRefVisible = _useState2[1];
  var current_user = JSON.parse(sessionStorage.getItem('user'));
  var annotation = attachment.annotation,
    can_annotate = attachment.can_annotate,
    is_document = attachment.is_document,
    is_image = attachment.is_image,
    is_video = attachment.is_video,
    is_audio = attachment.is_audio,
    annotatable = attachment.annotatable,
    slug = attachment.slug,
    name = attachment.name,
    view_url = attachment.view_url,
    download = attachment.download;
  var ext = getFileExtension(name);
  useEffect(function () {
    if (!refVisible) {
      return;
    }
    WebViewer({
      annotationUser: current_user.name,
      path: '/packs/js/assets/webviewer'
    }, viewer.current).then(function (instance) {
      var Core = instance.Core,
        UI = instance.UI;
      var Feature = UI.Feature;
      var documentViewer = Core.documentViewer,
        annotationManager = Core.annotationManager;
      UI.setHeaderItems(function (header) {
        header.shift();
        header.shift();
      });
      UI.disableFeatures([Feature.Download, Feature.Print]);
      UI.loadDocument(view_url, {
        filename: name,
        extension: ext
      });
      can_annotate ? annotationManager.disableReadOnlyMode() : annotationManager.enableReadOnlyMode();
      documentViewer.addEventListener('documentLoaded', function () {
        var el = document.getElementById('webviewer');
        el.classList.add("webviewer");

        // load the annotations
        annotationManager.importAnnotations(annotation === null || annotation === void 0 ? void 0 : annotation.data);
        if (download) {
          downloadFile(instance);
        }
        annotationManager.addEventListener('annotationChanged', function (annotations, action, _ref2) {
          var imported = _ref2.imported;
          // If the event is triggered by importing then it can be ignored
          // This will happen when importing the initial annotations from the server or individual changes from other users
          if (imported) return;
          var annot = annotations[0];
          annot.setCustomData('userId', current_user.id);
          annot.setCustomData('authorName', annotationManager.getCurrentUser());
          var xfdfString = annotationManager.exportAnnotations();
          xfdfString.then(function (data) {
            return updateAnnotations(data, slug, handleOnSuccess, handleOnError);
          });
        });
        var mapNames = function mapNames(authorName) {
          return authorName;
        };
        annotationManager.setAnnotationDisplayAuthorMap(mapNames);
      });
    }).catch(function (err) {
      return console.error('err ', err);
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refVisible]);
  var modalBodyContent;
  if (attachment.view_url && annotatable) {
    modalBodyContent = /*#__PURE__*/React.createElement("div", {
      ref: function ref(el) {
        viewer.current = el;
        setRefVisible(!!el);
      },
      id: "webviewer"
    });
  } else if (is_document || is_image) {
    modalBodyContent = /*#__PURE__*/React.createElement("div", {
      className: "webviewer"
    }, /*#__PURE__*/React.createElement("img", {
      src: view_url,
      className: "img-fluid",
      alt: ""
    }));
  } else if (is_video) {
    modalBodyContent = /*#__PURE__*/React.createElement("div", {
      className: "embed-responsive embed-responsive-16by9 webviewer"
    }, /*#__PURE__*/React.createElement("iframe", {
      title: "video-attachment",
      allow: "autoplay;fullscreen",
      className: "embed-responsive-item",
      frameBorder: "0",
      scrolling: "no",
      allowFullScreen: true,
      style: {
        width: '100%',
        height: '100%'
      },
      src: "https://onelineplayer.com/player.html?autoplay=false&autopause=false&muted=false&loop=false&time=true&progressBar=true&overlay=true&muteButton=true&fullscreenButton=true&style=light&quality=auto&playButton=true&url=".concat(encodeURIComponent(view_url))
    }));
  } else if (is_audio) {
    modalBodyContent = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ReactAudioPlayer, {
      src: view_url,
      style: {
        width: '100%'
      },
      autoPlay: true,
      controls: true
    }));
  } else {
    modalBodyContent = /*#__PURE__*/React.createElement("div", {
      className: "container my-2 webviewer"
    }, /*#__PURE__*/React.createElement(Alert, {
      color: "warning"
    }, "Oops! Looks like something went wrong. Try downloading the file directly instead."));
  }
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: show,
    toggle: toggle,
    modalClassName: "fixed-right",
    className: "modal-dialog-vertical",
    zIndex: 5000000000
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    toggle: toggle,
    tag: "h6",
    className: "card-header-title"
  }, "Attachment Preview ", ' ', /*#__PURE__*/React.createElement("span", {
    className: "text-muted font-weight-normal d-none",
    id: "saving-span"
  }, /*#__PURE__*/React.createElement("span", {
    className: "mx-2"
  }, "\u2022"), /*#__PURE__*/React.createElement("span", {
    className: "mx-2",
    id: "saving"
  }, "Saved!"))), /*#__PURE__*/React.createElement(ModalBody, null, " ", modalBodyContent, " "));
};
export default AttachmentPreviewer;